import * as React from "react";
import { SVGProps } from "react";
export const TriangleForwardIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.04199 14.958C7.74999 15.1527 7.45132 15.1633 7.14599 14.99C6.84065 14.816 6.68799 14.5553 6.68799 14.208V5.75C6.68799 5.40267 6.84065 5.14234 7.14599 4.969C7.45132 4.795 7.74999 4.80534 8.04199 5L14.688 9.25C14.9653 9.43067 15.104 9.67367 15.104 9.979C15.104 10.285 14.9653 10.528 14.688 10.708L8.04199 14.958ZM8.43799 12.646L12.583 9.979L8.43799 7.312V12.646Z"
            fill="currentColor"
        />
    </svg>
);
TriangleForwardIcon.displayName = "TriangleForwardIcon";
